export default __webpack_public_path__ + "static/media/oven-mode-normal.5e45fc5f.svg";